const contentSliders = document.querySelectorAll('.block-content-slider--4 .content-slider');

contentSliders.forEach((contentSlider) => {
	const nextButton = contentSlider.querySelector('.content-slider__next');
	const prevButton = contentSlider.querySelector('.content-slider__prev');
	new (window as Window).Swiper(contentSlider, {
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		watchOverflow: true,
		breakpoints: {
			300: {
				slidesPerView: 1.4,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 45,
			},
		},
	});
});

const postContentSliders = document.querySelectorAll('.block-content-slider--3 .content-slider');

postContentSliders.forEach((contentSlider) => {
	const nextButton = contentSlider.querySelector('.content-slider__next');
	const prevButton = contentSlider.querySelector('.content-slider__prev');
	new (window as Window).Swiper(contentSlider, {
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		slidesPerView: 1.1,
		spaceBetween: 16,
		watchOverflow: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 45,
			},
		},
	});
});
